import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { AssetSettings as OldAssetSettings } from "@models/tradable/split/asset_settings";

export interface AssetSettings {
	readonly id: number; // TODO unused?
	readonly isAvailable: boolean;
	readonly isBuyActive: boolean;
	readonly isDepositActive: boolean;
	readonly isIndexOnly: boolean;
	readonly isMaintenanceEnabled: boolean;
	readonly minBuyEur: number;
	readonly minSellEur: number;
	readonly isSellActive: boolean;
	readonly sort: number;
	readonly isTransferActive: boolean;
	readonly walletMinDeposit: number;
	readonly walletSmallDeposit: number;
	readonly walletSmallDeposit_fee: number;
	readonly isWithdrawActive: boolean;
	readonly isPriceOrderAvailable: boolean;
}

export class AssetSettingsAdapter extends BaseAdapter<OldAssetSettings, AssetSettings> {
	public adapt(item: OldAssetSettings): AssetSettings {
		if (!item) {
			return null;
		}

		return {
			id: Number(item.getId()),
			isAvailable: item.isAvailable() ?? false,
			isBuyActive: item.isBuyActive() ?? false,
			isDepositActive: item.isDepositActive() ?? false,
			isIndexOnly: item.isIndexOnly() ?? false,
			isMaintenanceEnabled: item.isMaintenance() ?? false,
			minBuyEur: item.getMinBuy() ?? 0,
			minSellEur: item.getMinSell() ?? 0,
			isSellActive: item.isSellActive() ?? false,
			sort: item.getSort() ?? 0,
			isTransferActive: item.isTransferActive() ?? false,
			walletMinDeposit: item.getWalletMinDeposit() ?? 0,
			walletSmallDeposit: item.getSmallDeposit() ?? 0,
			walletSmallDeposit_fee: item.getSmallDepositFee() ?? 0,
			isWithdrawActive: item.isWithdrawActive() ?? false,
			isPriceOrderAvailable: item.isPriceOrderAvailable() ?? false
		};
	}
}
